<template>
    <div class="saas-page linear-admin-workflow">
        <div class="saas-hero card-saas linear-page-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('template.template')}}</span>
                </p>
                <span class="linear-eyebrow">{{trans('template.template')}}</span>
                <h1 class="saas-hero__title">{{trans('template.template')}}</h1>
            </div>
            <div class="linear-command-actions" v-if="email_templates.total">
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" @click="showCreatePanel = !showCreatePanel">
                    <admin-icon name="plus"></admin-icon> {{ trans('template.add_new_template') }}
                </button>
            </div>
        </div>
        <transition name="fade">
            <div class="card-saas linear-admin-panel" v-if="showCreatePanel">
                <div class="linear-section-head">
                    <div>
                        <span>{{trans('template.template')}}</span>
                        <h4>{{trans('template.add_new_template')}}</h4>
                    </div>
                </div>
                <form class="linear-admin-form" @submit.prevent="submit" @keydown="templateForm.errors.clear($event.target.name)">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="">{{trans('template.name')}}</label>
                                <input class="form-control" type="text" value="" v-model="templateForm.name" name="name" :placeholder="trans('template.name')">
                                <show-error :form-name="templateForm" prop-name="name"></show-error>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="">{{trans('template.category')}}</label>
                                <v-select label="name" v-model="selected_category" name="category" id="category" :options="categories" :placeholder="trans('template.select_category')" @select="onCategorySelect" @close="templateForm.errors.clear('category')" @remove="templateForm.category = ''"></v-select>
                                <show-error :form-name="templateForm" prop-name="category"></show-error>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap gap-2 justify-content-end">
                        <button type="button" class="btn btn-sm admin-form-btn-cancel" @click="showCreatePanel = false">{{trans('general.cancel')}}</button>
                        <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('general.save')}}</button>
                    </div>
                </form>
            </div>
        </transition>
        <div class="admin-list-table-card linear-table-card mt-3" v-if="email_templates.total">
            <div class="linear-section-head linear-section-head--table">
                <div>
                    <span>{{trans('template.template')}}</span>
                    <h4>{{trans('template.template')}}</h4>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table admin-data-table linear-dense-table mb-0">
                    <thead>
                        <tr>
                            <th>{{trans('template.name')}}</th>
                            <th>{{trans('template.category')}}</th>
                            <th>{{trans('template.subject')}}</th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="email_template in email_templates.data" :key="email_template.id">
                            <td><span class="linear-table-primary" v-text="email_template.name"></span></td>
                            <td><span class="linear-pill" v-text="toWord(email_template.category)"></span></td>
                            <td><span class="linear-table-muted linear-table-truncate" v-text="email_template.subject"></span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item-button @click.prevent="editEmailTemplate(email_template)">
                                        <admin-icon name="pencil"></admin-icon> {{ trans('template.edit_template') }}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                        v-if="!email_template.is_default"
                                        v-confirm="{ok: confirmDelete(email_template)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('template.delete_template') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterEmailTemplateForm.page_length" :records="email_templates" @updateRecords="getEmailTemplates" @change.native="getEmailTemplates"></pagination-record>
            </div>
        </div>
        <div class="admin-list-table-card admin-empty-state linear-empty-state mt-3" v-if="!email_templates.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="mail"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
                <p class="admin-empty-state__text">{{trans('template.template')}}</p>
                <div class="mt-3">
                    <button class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" v-if="!showCreatePanel" @click="showCreatePanel = !showCreatePanel"><admin-icon name="plus"></admin-icon> {{trans('general.add_new')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import vSelect from 'vue-multiselect'

    export default {
        components : { vSelect },
        data() {
            return {
                showCreatePanel: false,
                email_templates: {
                    total: 0,
                    data: []
                },
                filterEmailTemplateForm: {
                    page_length: helper.getConfig('page_length')
                },
                templateForm: new Form({
                    name: '',
                    category: ''
                }),
                categories: [
                    {name: i18n.user.user, id: 'user'}
                ],
                selected_category: null
            };
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('email_template')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getEmailTemplates();
        },
        methods: {
            getEmailTemplates(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterEmailTemplateForm);
                axios.get('/api/email-template?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.email_templates = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editEmailTemplate(email_template){
                this.$router.push('/email-template/'+email_template.id+'/edit');
            },
            confirmDelete(email_template){
                return dialog => this.deleteEmailTemplate(email_template);
            },
            deleteEmailTemplate(email_template){
                axios.delete('/api/email-template/'+email_template.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getEmailTemplates();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            toWord(value){
                return helper.toWord(value);
            },
            submit(){
                this.templateForm.post('/api/email-template')
                    .then(response => {
                        toastr.success(response.message);
                        this.selected_category = null;
                        this.showCreatePanel = false;
                        this.getEmailTemplates();
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            onCategorySelect(selectedOption){
                this.templateForm.category = selectedOption.id;
            }
        }
    }
</script>

<style scoped>
.linear-page-hero {
    align-items: center;
}

.linear-eyebrow,
.linear-section-head span {
    color: #635bff;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-command-actions {
    display: flex;
    justify-content: flex-end;
}

.linear-admin-panel {
    padding: 1.15rem;
}

.linear-section-head {
    margin-bottom: 1rem;
}

.linear-section-head h4 {
    margin: 0.25rem 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-section-head--table {
    margin: 0;
    padding: 0.95rem 1.125rem;
    border-bottom: 1px solid #e2e8f0;
}

.linear-admin-form label {
    color: #475569;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.linear-admin-form .form-control {
    border-color: #e2e8f0;
    border-radius: 10px;
}

.linear-table-card,
.linear-empty-state {
    overflow: hidden;
    border-radius: 14px;
}

.linear-dense-table tbody td {
    vertical-align: middle;
}

.linear-table-primary {
    color: #0f172a;
    font-weight: 800;
}

.linear-table-muted {
    color: #64748b;
}

.linear-table-truncate {
    display: block;
    max-width: 34rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.linear-pill {
    display: inline-flex;
    align-items: center;
    min-height: 1.5rem;
    padding: 0 0.6rem;
    border: 1px solid #e0e7ff;
    border-radius: 999px;
    color: #4f46e5;
    background: #eef2ff;
    font-size: 0.75rem;
    font-weight: 800;
}

@media (max-width: 575.98px) {
    .linear-page-hero {
        align-items: flex-start;
    }

    .linear-command-actions {
        justify-content: flex-start;
        width: 100%;
    }
}
</style>
